import { Grid } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import {
  Header,
  InputType,
  TableComponent
} from 'src/pages/analytics/simulator/pricing-simulator/types/generic-table.model';
import getTableColumns from 'src/pages/analytics/simulator/common/features/table/columns-prep';
import DisplayCell from 'src/pages/analytics/simulator/pricing-simulator/components/table-columns/display-cell';
import { extractFieldsFromFormulae } from 'src/pages/analytics/simulator/pricing-simulator/utils/column-utils';
import { calculateValueFromFormula } from 'src/pages/analytics/simulator/pricing-simulator/utils/number-utils';

export const columnHelper = createColumnHelper<{
  [key: string]: number | string;
}>();

export const getHeaderName = (columnData) =>
  columnData.parent.is_info_enable === true ? (
    <Tooltip title={columnData.parent.info_details}>
      <InfoOutlinedIcon
        style={{
          fontSize: '14px',
          paddingTop: '0px',
          marginLeft: '6px'
        }}
      />
    </Tooltip>
  ) : null;

export function getTableColumnData(
  columnMetadata: any,
  componentType: TableComponent,
  columnHeaders: any,
  footerRows: any[] = [],
  inputsDisabled = false,
  moduleId?: number,
  sourceId?: number,
  scenarioId?: number,
  visibleColumns?: any,
  pricingAction1Value?: any,
  activeHeader?: any
) {
  const columnData = getTableColumns(
    columnMetadata,
    columnHeaders,
    componentType,
    footerRows,
    inputsDisabled,
    moduleId,
    sourceId,
    scenarioId,
    visibleColumns,
    pricingAction1Value,
    activeHeader
  );
  return columnData;
}

export const calculateValueUsingFormula: any = (columnMetadata, rowData) => {
  let selectChangedFormulaVal: number | string;
  if (columnMetadata.parent.formula == '') {
    selectChangedFormulaVal =
      rowData.parent.data[columnMetadata.parent.parent_field];
  } else {
    const fields = extractFieldsFromFormulae(columnMetadata.parent.formula);
    selectChangedFormulaVal = calculateValueFromFormula(
      columnMetadata.parent.formula,
      rowData.parent.data,
      fields
    );
  }
  return selectChangedFormulaVal;
};

export function getOutputColumnWithoutToggle(
  simTableViewMetadata: Header[],
  footerRows: any[] = [],
  rowData: any = {},
  componentType: TableComponent = TableComponent.INNOVATION
) {
  return [
    columnHelper.group({
      id: 'static-header',
      header: ({ table }) => (
        <Grid container justifyContent='space-between'>
          <Grid item>Sim Results</Grid>
        </Grid>
      ),
      columns: simTableViewMetadata.map<
        ColumnDef<{ [key: string]: number | string }>
      >((columnMetadata, index, self) => ({
        accessorKey: columnMetadata.parent.parent_field,
        enableSorting: true,
        header: (props) => (
          <Tooltip title={columnMetadata.parent.alias}>
            <span>{columnMetadata.parent.alias}</span>
          </Tooltip>
        ),
        cell: (info) => (
          <DisplayCell
            colorCode={columnMetadata.parent.is_cf_enable}
            value={info.getValue() as number}
            columnMetadata={columnMetadata}
            rowData={info.row}
          />
        ),
        meta: {
          className: 'last simulation-results',
          style: {},
          rowData,
          isOutputColumn: true
        },
        footer: (props) => {
          const data = footerRows.length
            ? footerRows[0].parent.data[columnMetadata.parent.parent_field]
            : '';
          // in case of IMO action column, no footer is required
          if (columnMetadata.parent.field_format === InputType.OVERWRITE) {
            return <span />;
          }
          return (
            <DisplayCell
              colorCode={columnMetadata.parent.is_cf_enable}
              columnMetadata={columnMetadata}
              value={data as number}
            />
          );
        }
      })),
      meta: {
        className: 'last simulation-results',
        isOutputColumn: true
      }
    })
  ];
}
